/* tslint:disable */
/* eslint-disable */
/**
 * GlassHouse.Dashboard.Api | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ApiUserTasksGetLastSelectedIdParameter
 */
export interface ApiUserTasksGetLastSelectedIdParameter {
}

/**
 * Check if a given object implements the ApiUserTasksGetLastSelectedIdParameter interface.
 */
export function instanceOfApiUserTasksGetLastSelectedIdParameter(value: object): value is ApiUserTasksGetLastSelectedIdParameter {
    return true;
}

export function ApiUserTasksGetLastSelectedIdParameterFromJSON(json: any): ApiUserTasksGetLastSelectedIdParameter {
    return ApiUserTasksGetLastSelectedIdParameterFromJSONTyped(json, false);
}

export function ApiUserTasksGetLastSelectedIdParameterFromJSONTyped(json: any, ignoreDiscriminator: boolean): ApiUserTasksGetLastSelectedIdParameter {
    return json;
}

export function ApiUserTasksGetLastSelectedIdParameterToJSON(json: any): ApiUserTasksGetLastSelectedIdParameter {
    return ApiUserTasksGetLastSelectedIdParameterToJSONTyped(json, false);
}

export function ApiUserTasksGetLastSelectedIdParameterToJSONTyped(value?: ApiUserTasksGetLastSelectedIdParameter | null, ignoreDiscriminator: boolean = false): any {
    return value;
}

